import React from "react";

export default function SQL_Injection() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Injection</h1>
      <p>This is the SQL_Injection component generated from the SQL JSON.</p>
    </div>
  );
}
